import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/index';
import { WizardStepContainer, WizardStepTitle } from './partials';
import { useLocalizedMessage } from '../../../../../util/useLocalizedMessage';

const imageUrl = require('assets/wizard/wizard-welcome.png');

const WizardWelcomeStep = ({ surfaceVariant }) => {
  const localizeMessage = useLocalizedMessage();
  const keyPrefix = surfaceVariant === 'cloud-data'
    ? 'cloud.dataWizard.welcome'
    : 'onboarding.welcome';

  return (
    <div className={classNames('wizard-step', 'wizard-step-welcome')}>
      <WizardStepContainer align="center">
        <div className="row">
          <div className="col-12">
            <div className="image-container">
              <img
                className="image"
                src={imageUrl}
                alt={localizeMessage(`${keyPrefix}.image.alt`)}
              />
            </div>
          </div>
        </div>
        <div className="row title-row">
          <div className="col-12">
            <WizardStepTitle title={localizeMessage(`${keyPrefix}.title`)} />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="welcome-text">
              <p className="welcome-text__primary">
                {localizeMessage(`${keyPrefix}.text.primary`)}
              </p>
              <p className="welcome-text__normal">
                {localizeMessage(`${keyPrefix}.text.line1`)}
              </p>
              <p className="welcome-text__normal">
                {localizeMessage(`${keyPrefix}.text.line2`)}
              </p>
            </div>
          </div>
        </div>
      </WizardStepContainer>
    </div>
  );
};

WizardWelcomeStep.propTypes = {
  surfaceVariant: PropTypes.oneOf(['legacy', 'cloud-data']),
};

WizardWelcomeStep.defaultProps = {
  surfaceVariant: 'legacy',
};

export default WizardWelcomeStep;
